import { useNavigate, useSearch } from "@tanstack/react-router"
import type { FC } from "react"
import { useCallback } from "react"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import { SupplierReportFilter } from "@/screens/Procurement/Supplier/components/Filters/SupplierReportFilter"
import { SupplierReportFilterSchema } from "@/screens/Procurement/Supplier/types/supplierReportFilter"
import { getRefinedSearchParams } from "@/utils/getRefinedSearchParams"

interface SupplierReportSearchFilterProps {
  showFilterDrawer: boolean
  toggleDrawer: () => void
}

export const SupplierReportFilterDrawer: FC<SupplierReportSearchFilterProps> = ({ showFilterDrawer, toggleDrawer }) => {
  const navigate = useNavigate({ from: "/app/procurement/_layout/supplier-report" })
  const currentSearch = useSearch({
    from: "/app/procurement/_layout/supplier-report",
    strict: true,
  })

  const handleClearFilters = useCallback(() => {
    const {
      search: { query, ...rest },
      replace,
    } = getRefinedSearchParams(currentSearch, SupplierReportFilterSchema.parse({}))
    void navigate({ search: { ...rest, query: currentSearch?.query }, replace })
  }, [currentSearch, navigate])

  return (
    <SearchFilterDrawer toggleDrawer={toggleDrawer} open={showFilterDrawer} clear={handleClearFilters}>
      <SupplierReportFilter />
    </SearchFilterDrawer>
  )
}
